type TitleOptions = {
    key: string
    value: string
    label: string
    labelNative: string
}

/*
The list of possible person titles for each brand is stored on the message bundle
This function receives the messages and returns the options to pass to select
*/
export const getTitleOptions = (messages): TitleOptions[] => {
    return Object.keys(messages.titles).reduce((acc: TitleOptions[], title: string) => {
        const localizedLabel = messages.titles[title]()

        if (localizedLabel === '') return acc
        const valueAndKey = localizedLabel === messages.titles.other() ? '_custom' : localizedLabel

        return [
            ...acc, 
            {
                key: valueAndKey,
                value: valueAndKey,
                label: localizedLabel,
                labelNative: localizedLabel,
            }
        ]
    }, [])
}
